import * as types from "./mutation-types";

export const setLocale = ({ commit }, locale) => {
  localStorage.setItem("locale", locale);
  commit(types.SET_LOCALE, locale);
};

export const setCurrency = ({ commit }, currency) => {
  localStorage.setItem("currency", currency);
  commit(types.SET_CURRENCY, currency);
};

export default {
  setLocale,
  setCurrency,
};
